import { Injectable } from '@angular/core';
import { BarcodeParser, BarcodeParserType } from '../barcode-parser';
import {
  BarcodeElement,
  BarcodeInfo,
  BarcodeSyscode,
} from '../barcode-parser.service';

@Injectable({
  providedIn: 'root',
})
export class Ean13RusParser implements BarcodeParser {
  public readonly name: BarcodeParserType = 'EAN-13-INTERNAL-USE-RUS';
  public readonly syscode: BarcodeSyscode = 'EAN-13-INTERNAL-USE';

  parse(barcodeContent: string): BarcodeInfo {
    const elements: BarcodeElement[] = [];

    const gtin = barcodeContent.substring(1, 7);
    elements.push({
      ai: '01',
      title: 'GTIN',
      value: gtin,
      raw: gtin,
    });
    const weight = '0' + barcodeContent.substring(7, 12);
    elements.push({
      ai: '3103',
      title: 'NET WEIGHT (kg)',
      value: `${+weight / 1000}`,
      raw: weight,
    });

    return {
      elements: elements,
      symbology: 'EAN13',
      originalBarcode: barcodeContent,
      syscode: this.syscode,
    };
  }
}
